<template>
    <button
        :type="type"
        class="focus:shadow-outline-blue rounded-md border-iron-300 bg-white px-4 py-2 text-xs font-semibold tracking-widest text-iron-700 shadow-sm ease-in-out hover:text-iron-500 focus:border-blue-300 active:bg-iron-50 active:text-iron-800 inline-flex items-center border uppercase transition duration-150 focus:outline-none disabled:opacity-25"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "button",
        },
    },
};
</script>
